import { useMemo } from "react";
import { useTran } from "@/hooks";

import { useAuthStore } from "@/features/auth";
import { useRolesPermissionsStore } from "./useRolesPermissionsStore";
import { useOrganizationStore } from "@/features/organization";
import { useCompanyStore } from "@/features/company";
import { useUserStore } from "./useUserStore";
import { filterModulesByAudience } from "../utils/roles-permissions";
import {
  buildRoleOptions,
  resolveModuleAudience,
} from "../utils/user-role-options";

const ADMIN_ROLES = ["system_admin", "business_unit"];

export const useUserListDerived = () => {
  const { t } = useTran();
  const { userRole, user } = useAuthStore();
  const isAdminRole = ADMIN_ROLES.includes(userRole);
  const currentUserId = user?.userId || user?.id;
  const companyId = user?.companyId;

  const { roles, permissionsModules } = useRolesPermissionsStore();
  const { createForm } = useUserStore();
  const { tree: organizationTree, loading: organizationLoading } =
    useOrganizationStore();
  const { companyOptions, companiesLoading } = useCompanyStore();

  const roleOptions = useMemo(
    () =>
      buildRoleOptions({
        roles,
        companyId,
        currentRoleKey: userRole,
        t,
      }),
    [companyId, roles, t, userRole],
  );

  const createModuleAudience = useMemo(
    () =>
      resolveModuleAudience({
        roleValue: createForm.role,
        roles,
        isCompanyAdmin: isAdminRole,
      }),
    [createForm.role, isAdminRole, roles],
  );

  const createPermissionModules = useMemo(
    () => filterModulesByAudience(permissionsModules, createModuleAudience),
    [createModuleAudience, permissionsModules],
  );

  return {
    isAdminRole,
    currentUserId,
    roleOptions,
    createPermissionModules,
    companyOptions,
    companyLoading: companiesLoading,
    organizationTree,
    organizationLoading,
  };
};
